import { render } from "./policy.vue?vue&type=template&id=68cb48ba"
import script from "./policy.vue?vue&type=script&lang=js"
export * from "./policy.vue?vue&type=script&lang=js"

import "./policy.vue?vue&type=style&index=0&id=68cb48ba&lang=css"
script.render = render

export default script